import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import styles from '../TermsOfUse/TermsOfUse.module.css';
import SEO from '../../Components/SEO/SEO';
import { STATIC_PAGE_META } from '../../seo/pageMeta';

const SECTIONS = [
  { key: 'section1' },
  { key: 'section2' },
  { key: 'section3' },
  { key: 'section4' },
  { key: 'section5' },
  { key: 'section6' },
  { key: 'section7' },
  { key: 'section8' },
  { key: 'section9' },
  { key: 'section10' },
];

const PaymentPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <SEO {...STATIC_PAGE_META['payment-policy']} />
      <div className={styles.container}>
        <Link to="/" className={styles.backButton} aria-label={t('legal.back')}>
          <FiArrowLeft /> {t('legal.back')}
        </Link>
        <h1 className={styles.title}>{t('legal.paymentPolicy.title')}</h1>
        <p className={styles.lastUpdated}>{t('legal.paymentPolicy.lastUpdated')}</p>
        {SECTIONS.map(({ key }) => (
          <section key={key} className={styles.section}>
            <h2 className={styles.sectionTitle}>{t(`legal.paymentPolicy.${key}Title`)}</h2>
            <p className={styles.sectionBody}>{t(`legal.paymentPolicy.${key}Body`)}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default PaymentPolicy;
